var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wallet-connect"},[(!_vm.Token)?_c('div',{staticClass:"wallet",on:{"click":_vm.connect}},[_vm._v(" "+_vm._s(_vm.$t('ConnectWallet'))+" ")]):_c('div',{staticClass:"wallets"},[_vm._v(" "+_vm._s(_vm.address.substr(0,4))+"***"+_vm._s(_vm.address.substring(_vm.address.length - 4))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }